import { jsx as _jsx } from "react/jsx-runtime";
import { styled, Tab, Tabs } from '@mui/material';
import { useCallback } from 'react';
const StyledTabs = styled(Tabs)({ minHeight: 32 });
function renderItem(item) {
    return _jsx(Tab, { value: item.value, label: item.label }, item.value);
}
export function TabsFilter({ items, value, onChange, className, }) {
    const handleChange = useCallback((_, value) => {
        onChange?.(value);
    }, [onChange]);
    return (_jsx(StyledTabs, { className: className, TabIndicatorProps: { hidden: true }, variant: "scrollable", value: value, onChange: handleChange, children: items.map(renderItem) }));
}
